import { CatalogueCount } from 'api/query/catalogue/catalogue-count';
import { Database } from 'shared/database.enum';
import { DatabaseTitle } from './database-title';

const databaseTitles: DatabaseTitle[] = [
  {
    db: Database.MaternalAll,
    title: 'Maternals',
  },
  {
    db: Database.MaternalCorriedale,
    title: 'Corriedales',
  },
  {
    db: Database.MaternalFirstCrossSire,
    title: 'First cross sire breeds',
  },
  {
    db: Database.MaternalPrimeSAMMs,
    title: 'Prime SAMMs',
  },
  {
    db: Database.TerminalAll,
    title: 'Terminals',
  },
  {
    db: Database.TerminalShedders,
    title: 'Terminal Shedders',
  },
  {
    db: Database.Merino,
    title: 'Merinos',
  },
  {
    db: Database.Dohne,
    title: 'Dohnes',
  },
  {
    db: Database.Boer,
    title: 'Goats',
  },
  // *TEMA* Starts
  {
    db: Database.LambplanAll,
    title: 'Lambplan',
  },
  // *TEMA* End
];

/**
 * Returns database title.
 * @param db active database
 */
export const getDatabaseTitle = (db: Database) => databaseTitles.map((database) => (database.db === db ? database.title : ''));

/**
 * Returns object with catalogues counts for particular database.
 * @param countAll array with catalogues counts for all databases
 * @param db active database
 */
export const getDatabaseCatalogueCount = (countAll: CatalogueCount[], db: Database) => countAll.filter((count) => count.dbType === db);
